<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">

      <template slot="left" >
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-format-color-fill</v-icon>{{$t('profile.material.subsupplies')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <MaterialSupplySubForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import MaterialSupplySubForm from '../../components/materialsupplysub/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'MaterialSupplySub';

const { mapFields } = createHelpers({
  getterType: 'materialsupplysub/getField',
  mutationType: 'materialsupplysub/updateField'
});

export default {
  name: 'MaterialSupplySubCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    MaterialSupplySubForm
  },
  data() {
    return {
      item: {
        'materialSupply' : this.$route.params.parent
      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('materialsupplysub', ['create', 'reset'])
  }
};
</script>
